import * as types from '../actionTypes'

export const setScrollPos = (value: number) => {
  return {
    type: types.SET_SCROLL_POS,
    payload: value
  }
}
